<template>
    <div class="welcome-page">
        <div class="full-card">
            <div class="welcome-header">
                <div class="header-content">
                    <img :src="getLogo || defaultLogo" alt="Setup Illustration" class="hero-img" />
                    <div class="user-meta">
                        <img :src="getAuthenticatedUser.avatar || defaultAvatar" alt="User Photo" class="user-photo" />
                        <div>
                            <h1>Welcome, {{ fullName }}!</h1>
                        </div>
                    </div>
                    <p class="setup-note">
                        ⚠️ Please do not refresh or close this page while we finalize your setup.
                    </p>
                </div>
            </div>

            <div class="steps-container">
                <div v-for="(step, index) in steps" :key="index" class="step-card">
                    <div class="icon-wrapper">
                        <i v-if="step.done" class="ph ph-check-circle step-done"></i>
                        <div v-else class="loader"></div>
                    </div>
                    <p class="step-description">{{ step.text }}</p>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters } from "vuex";
import CryptoJS from "crypto-js";
import { setApplicationSetup } from "@/repo/appSettingRepo";
import UserHelper from "@/mixins/UserHelper";
// import { clearDB } from "@/repo/appSettingRepo.js";
import WhiteLabelConfig from "../../config/app";

export default {
    computed: {
        ...mapGetters("company", ["getCompaniesByEmail","getContactLoginSlug", "getSingleCompanyLogo"]),
        ...mapGetters("auth", [
            "getAuthenticationStatus",
            "getUserSignInErrors", "getAuthenticatedUser"
        ]),

        user() {
            return this.getAuthenticatedUser || {};
        },
        fullName() {
            return `${this.user.first_name || ""} ${this.user.last_name || ""}`.trim();
        },
        getLogo() {
            return this.getSingleCompanyLogo ? `${WhiteLabelConfig.S3_BUCKET_URL}/${this.getSingleCompanyLogo}` : ''
        }

    },
    data() {
        return {
            defaultAvatar: "https://cdn-icons-png.flaticon.com/512/847/847969.png",
            defaultLogo: "../../assets/logo.webp",
            userWorkspaceList: [],
            currentWorkspace: {},
            applicationSettings: {},
            steps: [
                { text: 'Verifying your browser configuration!', done: false },
                { text: 'Fetching Your License information', done: false },
                { text: 'Fetching your workspace and theme configurations', done: false },
                { text: 'Fetching Your Profile', done: false },
                { text: 'Finalizing your application', done: false }
            ],
            interval: null
        }
    },

    mixins: [UserHelper],
    mounted() {
        this.applicationSettings = WhiteLabelConfig;
        this.setUpApplication();
    },
    methods: {
        async setUpApplication() {
            this.steps[0].done = true;
            // let params = {
            //     slug: this.getAuthenticatedUser.company_id,
            // };
            // await this.$store.dispatch("company/fetchCompanyById", params);
            await this.$store.dispatch("company/fetchCompanyLogo",this.getAuthenticatedUser.company_id),
            this.steps[1].done = true;

            this.$store.commit("errors/reset", null, { root: true });
            let redirect_url = "";
            if (this.$route?.query?.redirect_url) {
                let reb64 = CryptoJS.enc.Hex.parse(this.$route.query.redirect_url);
                let bytes = reb64.toString(CryptoJS.enc.Base64);
                let decrypt = CryptoJS.AES.decrypt(bytes, "esignsRedirect");
                let plain = decrypt.toString(CryptoJS.enc.Utf8);
                let obj = JSON.parse(plain);
                redirect_url = obj.path;
            }
            this.$store.commit("auth/setAppMode", true, { root: true });
            this.steps[2].done = true;
            await setApplicationSetup();
            this.steps[3].done = true;
            this.steps[4].done = true;
            this.steps.push({ text: "Please wait we will redirect to your dashboard!", done: false })
            await this.checkAndUpdateData(redirect_url);
        },
        async fetchUserData() {
            await this.$store.dispatch(
                "auth/fetchUsersWithEmail",
                this.getAuthenticatedUser.email
            );
            if (this.getWorkspaceList) {
                this.userWorkspaceList = this.getWorkspaceList;
                let hasIndividual = this.getAuthenticatedUser.workspace.findIndex(
                    (u) => u.plan_type == "INDIVIDUAL"
                );
                if (hasIndividual != -1) {
                    let individualWorkspace = {};
                    if (this.getAuthenticatedUser.workspace[hasIndividual].company_id) {
                        this.$set(
                            individualWorkspace,
                            "_id",
                            "" + this.getAuthenticatedUser.workspace[hasIndividual].company_id
                        );
                    } else {
                        this.$set(individualWorkspace, "_id", "0");
                    }
                    this.$set(individualWorkspace, "name", "INDIVIDUAL");
                    this.userWorkspaceList[hasIndividual]["company_id"] =
                        individualWorkspace;
                    if (this.currentWorkspace.plan_type == "INDIVIDUAL") {
                        if (this.getAuthenticatedUser.workspace[hasIndividual].company_id) {
                            this.currentWorkspace["company_id"] =
                                "" +
                                this.getAuthenticatedUser.workspace[hasIndividual].company_id;
                        } else {
                            this.currentWorkspace["company_id"] = "0";
                        }
                    }
                }
                this.$store.commit("auth/setActiveWorkspace", this.currentWorkspace, {
                    root: true,
                });
                this.$store.commit("auth/setWorkspaceList", this.userWorkspaceList, {
                    root: true,
                });
            } else {
                this.userWorkspaceList = [];
            }
        },
        async getCompanyUserType() {
            try {
                await this.$store.dispatch(
                    "auth/getUserTypeById",
                    this.currentWorkspace.user_type
                );
            } catch (err) {
                console.log("getCompanyUserType", err);
                this.$notify.error({
                    title: "Error",
                    message: err,
                });
            }
        },
    }

};
</script>

<style scoped>
.welcome-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3rem 1rem;
    min-height: 100vh;
    position: relative;
    overflow: hidden;
    z-index: 1;
    /* //color: #fff; */
    background-color: rgb(255 255 255 / 15%);
}

.welcome-page::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -2;
    background-image:
        linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
        url("../../assets/7714.jpg"),
        linear-gradient(160deg, #1e3c72, #2a5298);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    filter: brightness(1);
    /* animation: panBackground 20s linear infinite; */
}

@keyframes panBackground {
    0% {
        background-position: 0% 0%;
    }

    100% {
        background-position: 100% 100%;
    }
}



.welcome-header {
    text-align: center;
    max-width: 600px;
    margin-bottom: 2rem;

    h1 {
        color: #2f3169;
    }
}

.hero-img {
    width: 280px;
    margin-bottom: 1rem;
}

.setup-note {
    color: #d32f2f;
    font-weight: 600;
    font-size: 0.85rem;
    margin-top: 0.5rem;
}

.steps-container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.5rem;
    width: 100%;
    /* max-width: 500px; */
}

.full-card {

    align-items: center;
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
    padding: 1rem 1.2rem;
    transition: background 0.3s ease;
    /* background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2); */

    background-color: rgb(255 255 255 / 99%);
    border: 1px solid rgb(30 2 2 / 20%);
    backdrop-filter: blur(6px);
    color: #fff;

    @media (min-width: 1024px) {
        display: flex;
    }

}

.step-card {
    display: flex;
    align-items: center;
    border-radius: 12px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
    padding: 1rem 1.2rem;
    transition: background 0.3s ease;
    /* background-color: rgba(91, 61, 140, 0.7);
   */
    background: #00000008;
    border: 1px solid rgb(23 37 138 / 39%);
    backdrop-filter: blur(6px);
    color: #195d8e;
    box-shadow: inset 0 0 1px #fff3, 0 1px 4px rgba(0, 0, 0, 0.2);
}

.icon-wrapper {
    width: 32px;
    height: 32px;
    margin-right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.loader {
    border: 3px solid #212931;
    border-top-color: transparent;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    animation: spin 1s linear infinite;
}

.step-done {
    font-size: 24px;
    color: #4caf50;
}

.step-description {
    font-size: 1.1rem;
    font-weight: 500;
    color: #101010;
}




@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.setup-wrapper {
    background: rgba(255, 255, 255, 0.06);
    backdrop-filter: blur(20px);
    border-radius: 20px;
    padding: 2rem;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
    max-width: 600px;
    margin: 0 auto;
}


.header-content {
    display: flex;
    align-items: center;
    gap: 2rem;
    justify-content: center;
    flex-wrap: wrap;
}

/* .hero-img {
  width: 100px;
  height: auto;
} */

.user-meta {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.user-photo {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border: 2px solid #ffffffcc;
    object-fit: cover;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
</style>